import React from 'react';
import apiConfig from '@/api/config';
import { useAppSelector } from '@/store/hooks';

interface RoomErrorPageProps {
  type: 'NOT_FOUND' | 'EXPIRED' | 'PARTICIPANT_LIMITED' | 'CONFERENCE_REFUSAL';
}

const MESSAGES: Record<RoomErrorPageProps['type'], { title: string; desc: React.ReactNode }> = {
  NOT_FOUND: {
    title: '개설되지 않은 화상회의 방입니다.',
    desc: <>주소가 잘못되었거나 개설자가 취소 또는 삭제한 화상회의입니다.<br />참여자에게 회의주소를 다시 확인해 주시기 바랍니다.</>,
  },
  EXPIRED: {
    title: '종료된 회의입니다.',
    desc: <>화상회의가 삭제되었거나<br />마스터가 이 회의를 종료했습니다.</>,
  },
  PARTICIPANT_LIMITED: {
    title: '참석 인원이 초과하였습니다.',
    desc: <>회의에 참석 가능한 인원은 최대 50명입니다.<br />마스터에게 문의해주세요.</>,
  },
  CONFERENCE_REFUSAL: {
    title: '참석 요청 거절',
    desc: (
      <>
        마스터가 참석 요청을 거절했습니다.
        <br />
        다른 회의를 개설하거나 마스터에게 문의하세요.
      </>
    ),
  },
};

const RoomErrorPage: React.FC<RoomErrorPageProps> = ({ type }) => {
  const local = useAppSelector((s) => s.local);
  const title = local.roomName || local.roomId || '';

  const goWehagoMain = () => {
    const portalUrl = apiConfig.portalBaseUrl || '/';
    window.location.href = portalUrl;
  };

  const msg = MESSAGES[type];

  return (
    <div id="wrap" className="rtc rtc_new rtc_new3 wrap notosans_font">
      <div id="header" className="header">
        <div className="rtc_header rtc_header__end notosans_font">
          <div className="main_title">
            <h1>
              <a href="#" onClick={(e) => { e.preventDefault(); goWehagoMain(); }}>
                <img
                  src="https://static.wehago.com/imgs/common/wehago_w.svg"
                  width={109}
                  height={22}
                  alt="WEHAGO"
                />
              </a>
            </h1>
          </div>
          {title && (
            <div className="service_title">
              <h2>{title}</h2>
            </div>
          )}
        </div>
      </div>
      <div className="rtcNew_container rtcNew_container--setting notosans_font">
        <div className="rtcEmpty">
          <h1 className="rtcEmpty__title dzt_font hasImage">
            {msg.title}
          </h1>
          <p className="rtcEmpty__desc">
            {msg.desc}
          </p>
          <div className="rtcEmpty__btnbox">
            <button
              type="button"
              className="common_round_btn sizeBig"
              onClick={goWehagoMain}
            >
              WEHAGO 메인으로
            </button>
          </div>
          <p className="rtcEmpty_footer">
            Copyright © DOUZONE BIZON. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoomErrorPage;
